"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRes = getRes;
exports.getI18n = getI18n;
var i18next_1 = require("i18next");
var i18next_icu_1 = __importDefault(require("i18next-icu"));
var common_1 = require("@altus-ui/common");
// Import all locale files directly
var enApiTokens = __importStar(require("../messages/en/api_tokens.json"));
var enBareMetal = __importStar(require("../messages/en/bare_metal.json"));
var enBucketTokens = __importStar(require("../messages/en/bucket_tokens.json"));
var enCommon = __importStar(require("../messages/en/common.json"));
var enCompute = __importStar(require("../messages/en/compute.json"));
var enCostUsage = __importStar(require("../messages/en/cost_usage.json"));
var enCredentials = __importStar(require("../messages/en/credentials.json"));
var enCredits = __importStar(require("../messages/en/credits.json"));
var enDashboard = __importStar(require("../messages/en/dashboard.json"));
var enDataSync = __importStar(require("../messages/en/data_sync.json"));
var enEndpoints = __importStar(require("../messages/en/endpoints.json"));
var enHome = __importStar(require("../messages/en/home.json"));
var enInvoices = __importStar(require("../messages/en/invoices.json"));
var enJobs = __importStar(require("../messages/en/jobs.json"));
var enKubernetes = __importStar(require("../messages/en/kubernetes.json"));
var enMain = __importStar(require("../messages/en/main.json"));
var enModelRegistry = __importStar(require("../messages/en/model_registry.json"));
var enMonitoring = __importStar(require("../messages/en/monitoring.json"));
var enNotebook = __importStar(require("../messages/en/notebook.json"));
var enNotifications = __importStar(require("../messages/en/notifications.json"));
var enObjectStorage = __importStar(require("../messages/en/object_storage.json"));
var enPublicSite = __importStar(require("../messages/en/public_site.json"));
var enPvc = __importStar(require("../messages/en/pvc.json"));
var enQuotas = __importStar(require("../messages/en/quotas.json"));
var enSlurm = __importStar(require("../messages/en/slurm.json"));
var enStorage = __importStar(require("../messages/en/storage.json"));
var enUsers = __importStar(require("../messages/en/users.json"));
var enWorkspace = __importStar(require("../messages/en/workspace.json"));
var koApiTokens = __importStar(require("../messages/ko/api_tokens.json"));
var koBareMetal = __importStar(require("../messages/ko/bare_metal.json"));
var koBucketTokens = __importStar(require("../messages/ko/bucket_tokens.json"));
var koCommon = __importStar(require("../messages/ko/common.json"));
var koCompute = __importStar(require("../messages/ko/compute.json"));
var koCostUsage = __importStar(require("../messages/ko/cost_usage.json"));
var koCredentials = __importStar(require("../messages/ko/credentials.json"));
var koCredits = __importStar(require("../messages/ko/credits.json"));
var koDashboard = __importStar(require("../messages/ko/dashboard.json"));
var koDataSync = __importStar(require("../messages/ko/data_sync.json"));
var koEndpoints = __importStar(require("../messages/ko/endpoints.json"));
var koHome = __importStar(require("../messages/ko/home.json"));
var koInvoices = __importStar(require("../messages/ko/invoices.json"));
var koJobs = __importStar(require("../messages/ko/jobs.json"));
var koKubernetes = __importStar(require("../messages/ko/kubernetes.json"));
var koMain = __importStar(require("../messages/ko/main.json"));
var koModelRegistry = __importStar(require("../messages/ko/model_registry.json"));
var koMonitoring = __importStar(require("../messages/ko/monitoring.json"));
var koNotebook = __importStar(require("../messages/ko/notebook.json"));
var koNotifications = __importStar(require("../messages/ko/notifications.json"));
var koObjectStorage = __importStar(require("../messages/ko/object_storage.json"));
var koPublicSite = __importStar(require("../messages/ko/public_site.json"));
var koPvc = __importStar(require("../messages/ko/pvc.json"));
var koQuotas = __importStar(require("../messages/ko/quotas.json"));
var koSlurm = __importStar(require("../messages/ko/slurm.json"));
var koStorage = __importStar(require("../messages/ko/storage.json"));
var koUsers = __importStar(require("../messages/ko/users.json"));
var koWorkspace = __importStar(require("../messages/ko/workspace.json"));
var enRes = Object.assign({}, enApiTokens, enBareMetal, enBucketTokens, enCommon, enCompute, enCostUsage, enCredentials, enCredits, enDashboard, enDataSync, enEndpoints, enHome, enInvoices, enJobs, enKubernetes, enMain, enModelRegistry, enMonitoring, enNotebook, enNotifications, enObjectStorage, enPublicSite, enPvc, enQuotas, enSlurm, enStorage, enUsers, enWorkspace);
var krRes = Object.assign({}, koApiTokens, koBareMetal, koBucketTokens, koCommon, koCompute, koCostUsage, koCredentials, koCredits, koDashboard, koDataSync, koEndpoints, koHome, koInvoices, koJobs, koKubernetes, koMain, koModelRegistry, koMonitoring, koNotebook, koNotifications, koObjectStorage, koPublicSite, koPvc, koQuotas, koSlurm, koStorage, koUsers, koWorkspace);
var i18nMap = {};
var localeRes = (_a = {},
    _a[common_1.Locale.ko_KR] = krRes,
    _a[common_1.Locale.en_US] = enRes,
    _a);
function getRes(locale) {
    return localeRes[locale] || enRes;
}
function getI18n(locale) {
    var _a;
    if (locale === void 0) { locale = common_1.Locale.en_US; }
    var key = "".concat(locale);
    if (i18nMap[key]) {
        return i18nMap[key];
    }
    var translation = getRes(locale);
    var i18nInstance = (0, i18next_1.createInstance)();
    i18nInstance.use(i18next_icu_1.default).init({
        lng: locale,
        interpolation: {
            escapeValue: false // not needed for react!!
        },
        // debug: true,
        resources: (_a = {},
            _a[locale] = {
                translation: translation
            },
            _a)
    });
    i18nMap[key] = {
        i18n: i18nInstance,
        t: i18nInstance.t
    };
    return i18nMap[key];
}
__exportStar(require("./constants"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./datetime"), exports);
